import { Component, OnInit } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { TemplateRef, ViewChild } from '@angular/core';
import { PagarService } from '@app/services/pagar.service';
import { ToastrService } from 'ngx-toastr';
import { RateioFaturamentoInput, RateioFaturamentoModel } from '@app/models/rateio-faturamento.model';
import debounce from '@app/utils/debounce';
import { ConsultasService } from '@app/services/consultas.service';
import { Rateio, RateioCriacaoInput } from '@app/models/rateio.model';
import { UtilitarioService } from '@app/services/utilitario.service';
import { IdDescricao } from '@app/models/util/id-descricao';
import { Router } from '@angular/router';

@Component({
  selector: 'app-rateio-form',
  templateUrl: './rateio-form.component.html'
})
export class RateioFormComponent implements OnInit {
  @ViewChild('selecaoFaturamentoBase', {static: true}) faturamentoBaseRef: TemplateRef<any>;
  bsModalRef: BsModalRef;

  lstFaturamentoOpcoes = [{ Id: 'MENSAL', Descricao: '1 mês' }, { Id: 'TRIMESTRAL', Descricao: '3 meses' }];
  lstFaturamentoMeses: string[] = [];
  faturamentoSelecao: string = 'MENSAL';

  titulo: string = 'NOVO RATEIO';
  aguardando: boolean = false;

  lstFaturamentosUnidades: Array<RateioFaturamentoModel> = [];

  lstParticipante: any[] = [];
  lstTipoDR: IdDescricao[] = [];

  filtro: RateioFaturamentoInput = new RateioFaturamentoInput();
  novoRateio: RateioCriacaoInput = new RateioCriacaoInput();

  somaTotalPercentuais: number = 0;
  _pesquisa: any;
  _debounce: any;

  constructor(
    private modalService: BsModalService,
    private toastr: ToastrService,
    private pagarService: PagarService,
    private router: Router,
    private consultasService: ConsultasService
  ) { }

  ngOnInit(): void {
    this.populaListaMesesFaturamento();
    this.consultasService.consultar('DR_D').subscribe(data => this.lstTipoDR = data);
    this.bsModalRef = this.modalService.show(this.faturamentoBaseRef, {
      keyboard: false,
      ignoreBackdropClick: true
    });
  }

  liberarRateio(){
    this.aguardando = true;
    this.pagarService.obterFaturamentoRateio(this.filtro).subscribe(
      data => {
        this.lstFaturamentosUnidades.push(... data.Dados);
        this.novoRateio.FaturamentoDataInicial = data.DataInicial;
        this.novoRateio.FaturamentoDataFinal  = data.DataFinal;
        this.novoRateio.Unidades = JSON.parse(JSON.stringify(data.Dados));
        this.novoRateio.Unidades.forEach(unidade => {
          unidade.UnidadePercentualSugerido = unidade.UnidadePercentual;
          this.somaTotalPercentuais += unidade.UnidadePercentual;
        });
        this.somaTotalPercentuais = Number(this.somaTotalPercentuais.toFixed(2));
        this.bsModalRef.hide();
        this.aguardando = false;
      },
      (erro) => {
        this.toastr.info(erro.error.errors[0], 'Tente novamente!');
        this.aguardando = false;
      }
    );
    
  }

  gravarRateio(){
    if(!this.validaRateio())
      return;

    this.aguardando = true;
    this.pagarService.gravarRateio(this.novoRateio).subscribe(
      () => this.router.navigate(['/financeiro/pagar']),
      (erro) => this.toastr.error(erro.error.errors[0]),
      () => this.aguardando = false
    )
  }

  validaRateio(){
    if(!this.novoRateio.ParticipanteId){
      this.toastr.error('Selecione um participante!');
      return false;
    }

    if(!this.novoRateio.Valor){
      this.toastr.error('Insira um valor!');
      return false;
    }

    if(!this.novoRateio.Vencimento){
      this.toastr.error('Selecione um vencimento!');
      return false;
    }

    if(this.novoRateio.NumeroParcelas < 1){
      this.toastr.error('O número mínimo de parcelas é 1!');
      return false;
    }

    let somaPercentuais = 0;
    this.novoRateio.Unidades.forEach(unidade => {
      somaPercentuais += Number(unidade.UnidadePercentual)
    });

    somaPercentuais = Number(somaPercentuais.toFixed(2));

    if(somaPercentuais !== 100.00){
      this.toastr.error('A soma dos percentuais deve ser exatamente igual 100.', 'Altere os percentuais!')
      return false;
    }
    
    return true;
  }

  atualizaSomaTotal(unidadeId: number){
    this.sanitizaPercentuais(unidadeId);
    this.somaTotalPercentuais = 0;
    this.novoRateio.Unidades.forEach(unidade => this.somaTotalPercentuais += unidade.UnidadePercentual);
  }
  sanitizaPercentuais(unidadeId: number){
    let unidade = this.novoRateio.Unidades.find(x => x.UnidadeId === unidadeId);
    unidade.UnidadePercentual = Number(unidade.UnidadePercentual.toString().replace(',','.'));
  }


  populaListaMesesFaturamento(){
    let contador = 1;
    while(contador <= 6){
      this.lstFaturamentoMeses.push(UtilitarioService.retornaDataUltimoDiaDoMesAnterior(contador));
      contador++;
    }
  }

  // verificaRegistrosEmEdicao(){
  //   return this.lstRateioUnidades.filter(x => x.Editando).length > 0
  // }

  // concluiEdicaoUnidade(idx){
  //   this.lstRateioUnidades[idx].Editando = false;
  //   this.lstRateioUnidades[idx].EdicaoConcluida = true;
  //   this.lstRateioUnidades[idx].UnidadeEditada = true;

  //   this.calculaPercentuaisPosEdicao(idx);
  // }

  // calculaPercentuaisPosEdicao(idx){
  //   //fazer distribuição proporcional para itens que não tiveram o valor alterado
  //   let somaTotal: number = 0;
  //   this.lstRateioUnidades.forEach(x => somaTotal +=  Number(x.UnidadePercentual));

  //   let diferencaPosEdicao = 100 - somaTotal;
  //   let indiceEditar = idx + 1;

  //   const indiceMaximo = this.lstRateioUnidades.length - 1;

  //   while(this.lstRateioUnidades[indiceEditar].UnidadeEditada && indiceEditar < indiceMaximo)
  //     indiceEditar++;

  //   if(this.lstRateioUnidades[indiceEditar].UnidadeEditada)
  //     return;

  //   this.lstRateioUnidades[indiceEditar].UnidadePercentual += diferencaPosEdicao;
  // }

  public ngxselect_typed(value: any): void {
    this.lstParticipante = [
      { Id: -1, Descricao: 'Pesquisando...' + value, disabled: true },
    ];
    this._pesquisa = value;
    if (!this._debounce) {
      this._debounce = debounce(() => {
        this.consultasService
          .consultar('PARTICIPANTE', this._pesquisa).toPromise()
          .then((data) => {
            this.lstParticipante = data;
          });
      }, 500);
    }
    this._debounce();
  }

}
